module.exports = __webpack_public_path__ + "img/dark-mud-decal-26.00a3f8f5.png";